// authService.js

const API_PREFIX = '/api';

export const getCurrentUser = () => {
  // Now we rely on the user object in localStorage only, not the token
  const userStr = localStorage.getItem('user');
  if (!userStr) return null;
  
  try {
    return JSON.parse(userStr);
  } catch (error) {
    console.error('Error parsing user data:', error);
    return null;
  }
};

export const logoutUser = async () => {
  try {
    // Call the logout endpoint to clear the cookie
    await fetch(API_PREFIX + '/auth/logout', {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      }
    });
  } catch (error) {
    console.error('Error during logout:', error);
  } finally {
    // Clear local storage user data
    localStorage.removeItem('user');
    // Navigate to login
   // Check if we're in dev path and maintain it
   if (window.location.pathname.includes('/dev')) {
    window.location.href = '/dev/login';
  } else {
    window.location.href = '/login';
  }
  }
};